import { ChangeEvent } from 'react';
import { FormField } from '@nimbus-ds/patterns';
import { InputNumberNimbus } from 'commons/components';
import { useTranslationAccount } from 'domains/Account/hooks';

interface TaxRateInputProps {
  value: number | null;
  name: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

function TaxRateInput({ name, value, onChange }: TaxRateInputProps) {
  const t = useTranslationAccount('businessDataPage.taxesWithExceptions');

  return (
    <FormField label={t('aliquotLabel')} id="taxRateException">
      <InputNumberNimbus
        type="float"
        name={name}
        onChange={onChange}
        value={value === null ? '' : String(value)}
        append="%"
        appendPosition="end"
        appearance="neutral"
      />
    </FormField>
  );
}
export default TaxRateInput;
